var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1730701248655,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 17359,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M927.996 639.313c0 49.602-40.068 89.903-86.298 89.903H191.38c-49.313 0-89.38-40.301-89.38-89.903v-415.41C102 174.301 142.067 134 191.38 134h650.317c49.314 0 86.299 40.301 86.299 89.903v415.41m-58.56-415.41c0-15.501-12.328-31.001-27.739-31.001H191.38c-15.411 0-30.82 12.401-30.82 31.001v415.41c0 15.501 12.328 31.001 30.82 31.001h650.317c15.411 0 27.739-15.501 27.739-31.001v-415.41M164.01 521.51h700.78v58.902H164.01V521.51m545.159 356.51H323.91c-15.41 0-30.82-12.4-30.82-31.001 0-15.5 12.328-31.001 30.82-31.001h385.26c15.411 0 30.82 12.4 30.82 31.001-3.082 18.6-15.41 31.001-30.821 31.001m-342.11-148.804h58.559v86.802h-58.559v-86.802m206.498 0h58.56v86.802h-58.56v-86.802m0 0z",
    fill: "#515151",
    "p-id": 17360
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIp);
export default __webpack_public_path__ + "static/media/ip.5403d8a2d2c764cbaff9278bc5eb3a7c.svg";
export { ForwardRef as ReactComponent };